import {
    addEventListener,
    ElementClickEvent,
    triggerElementClickEvent,
    triggerTierSelectionEvent,
    triggerSelectItemEvent,
    triggerViewItemListEvent,
    EventType,
    EcommerceSourceClickFragment,
    EcommerceSourceImpressionFragment,
    EcommerceTypeFragment,
    ElementSectionFragment
} from '@dazn/fe-events';

export interface TileImpression {
    tileTitle: string;
    assetId: string;
    assetType: any;
    tilePositionOnLoad: number;
    tilePositionOnView: number;
    numberOfTilesInRail: number;
    entitlementId: string;
    entitlementIds?: string[];
    railTitle: string;
    railId: string;
    railPosition: string;
    competitionId: string;
    competitionName: string;
    quantity?: any;
}

export interface SelectItemEventParams {
    tileTitle: string;
    assetId: string;
    assetType: any;
    pulseType: any;
    tilePositionOnLoad: number;
    tilePositionOnClick: number;
    numberOfTilesInRail: number;
    entitlementId?: string;
    entitlementIds?: any;
    railTitle: string;
    railId: string;
    railPosition: string;
    competitionId: string;
    competitionName: string;
    scheduleDate: string;
    scheduleFilter: string;
    type?: EcommerceTypeFragment;
    itemName?: EcommerceSourceClickFragment;
    quantity?: any;
}

export interface ViewItemListEventParams {
    tileImpressions: TileImpression[];
    scheduleDate: string;
    scheduleFilter: string;
    impressionName: EcommerceSourceImpressionFragment;
    type?: EcommerceTypeFragment;
}

export interface IElementClick {
    section: ElementSectionFragment;
    itemId?: any;
    resourceString: string;
}
export interface IEventMeta {
    deprecated: boolean;
    gtm: boolean;
    name: string;
}
export const callbackListener = (
    payload: EventType,
    meta: IEventMeta
): void => {
    if (meta?.deprecated || !meta?.gtm) {
        return;
    }

    if (!window.dataLayer) {
        window.dataLayer = [];
    }

    window.dataLayer.push({
        ...payload,
        event: meta.name
    });
};


export const unsubscribeEvents = addEventListener((payload, meta) => callbackListener(payload, meta as IEventMeta));

export const triggerTierSelectEvent = ({
    rank = 0,
    entitlementSetId = ''
}: {
    rank: number;
    entitlementSetId: string;
}): void => {
    const newEvent = {
        tier: {
            entitlementSetId: entitlementSetId as string,
            rank: rank as number
        }
    };
    triggerTierSelectionEvent(newEvent);
};
export enum ElementSection {
    Header = 'header',
    Body = 'body',
    Footer = 'footer'
}

export const triggerElementClick = ({
    section,
    itemId = '',
    resourceString
}: IElementClick): void => {
    const event: ElementClickEvent = {
        element: {
            type: section,
            itemType: 'element',
            itemId,
            itemName: resourceString
        }
    };

    triggerElementClickEvent(event);
};
const ecommerceCommonPayload = {
    scheduleDate: '',
    scheduleFilter: '',
    searchTerm: ''
};

export const triggerSelectItemList = ({
    tileTitle,
    assetId,
    assetType,
    tilePositionOnLoad,
    tilePositionOnClick,
    numberOfTilesInRail,
    entitlementId,
    railTitle,
    railId,
    railPosition,
    competitionId,
    competitionName,
    scheduleDate,
    scheduleFilter,
    type,
    itemName,
    pulseType
}: SelectItemEventParams) => {
    triggerSelectItemEvent({
        ecommerce: {
            ...ecommerceCommonPayload,
            scheduleDate,
            scheduleFilter: scheduleFilter || '',
            type: type || 'rail',
            continuousPlay: '',
            pulseType: pulseType,
            searchFilter: '',
            items: [
                {
                    ['item_name']: tileTitle,
                    ['item_id']: assetId || '',
                    ['item_brand']: assetType || '',
                    ['item_category']: String(tilePositionOnLoad),
                    ['item_category2']: String(tilePositionOnClick),
                    ['item_category3']: String(numberOfTilesInRail),
                    ['item_category4']: itemName || 'rail click',
                    ['item_category5']: false,
                    ['item_variant']: entitlementId || '',
                    ['item_list_name']: railTitle,
                    ['item_list_id']: railId,
                    ['item_competition_id']: competitionId || '',
                    ['item_competition_name']: competitionName || '',
                    index: String(railPosition)
                }
            ]
        }
    });
};

export const triggerViewItemList = ({
    tileImpressions,
    scheduleDate,
    scheduleFilter,
    impressionName,
    type
}: ViewItemListEventParams) => {
    triggerViewItemListEvent({
        ecommerce: {
            ...ecommerceCommonPayload,
            scheduleDate,
            scheduleFilter,
            type: type || 'schedule',
            continuousPlay: '',
            pulseType: '',
            searchFilter: '',
            items: tileImpressions?.map(
                ({
                    tileTitle,
                    assetId,
                    assetType,
                    tilePositionOnLoad,
                    tilePositionOnView,
                    numberOfTilesInRail,
                    entitlementId,
                    railTitle,
                    railId,
                    railPosition,
                    competitionId,
                    competitionName
                }) => {
                    return {
                        ['item_name']: tileTitle,
                        ['item_id']: assetId || '',
                        ['item_brand']: assetType || '',
                        ['item_category']: String(tilePositionOnLoad),
                        ['item_category2']: String(tilePositionOnView),
                        ['item_category3']: String(numberOfTilesInRail),
                        ['item_category4']:
                            impressionName || 'schedule impression',
                        ['item_category5']: false,
                        ['item_variant']: entitlementId,
                        ['item_list_name']: railTitle,
                        ['item_list_id']: railId,
                        ['item_competition_id']: competitionId || '',
                        ['item_competition_name']: competitionName || '',
                        index: String(railPosition)
                    };
                }
            )
        }
    });
};
